<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <div class="d-flex align-center justify-center">
      <page-header>
        数据和管理
      </page-header>
      <v-spacer />
      <v-btn
        class="amber lighten-4 text--black"
        outlined
        @click="settingManage = true"
      >
        设置
      </v-btn>
    </div>
    <v-item-group
      v-model="titleGroup"
      class="d-flex flex-wrap mt-4"
      mandatory
    >
      <div
        v-for="item in titleList"
        :key="item.id"
      >
        <v-item
          v-slot="{ active, toggle }"
        >
          <v-btn
            :class="active ? 'amber lighten-4' : ''"
            class="pa-4 mr-4 my-2"
            elevation="0"
            large
            outlined
            @click="toggle"
          >
            <div
              class="d-flex justify-center align-center"
            >
              <div>
                {{ item.type }}
              </div>
            </div>
          </v-btn>
        </v-item>
      </div>
    </v-item-group>
    <div v-if="reportType === '月报'">
      <v-card
        v-for="item in monthItems"
        :key="item.id"
        class="pa-4 mb-4"
        color="#eee"
        outlined
        width="100%"
      >
        <div class="d-flex text-body-1">
          <div>
            <div>@{{ item.date }}</div>
          </div>
          <v-spacer />
          <div>
            已提交: {{ item.percentage }}
          </div>
        </div>
        <div
          style="display: grid;
             grid-template-columns: repeat(8,minmax(0,1fr));
             grid-gap: 12px"
        >
          <v-card
            v-for="(it,index) in item.allStore"
            :key="index"
            class="mr-2 pa-2"
            elevation="0"
            outlined
          >
            <v-responsive :aspect-ratio="1">
              <div
                class="d-flex flex-column align-center justify-center"
                style="height: 100%"
              >
                <div>
                  {{ it.name }}
                </div>
                <v-spacer />
                <v-icon
                  v-if="it.reportFinished === 1"
                  color="green"
                >
                  mdi-check-circle-outline
                </v-icon>
              </div>
            </v-responsive>
          </v-card>
        </div>
      </v-card>
    </div>
    <div v-else-if="reportType === '周报'">
      <v-card
        v-for="item in weekItems"
        :key="item.id"
        class="pa-4 mb-4"
        color="#eee"
        outlined
        width="100%"
      >
        <div class="d-flex text-body-1">
          <div>
            <div>@{{ item.date }}</div>
          </div>
          <v-spacer />
          <div>
            已提交: {{ item.percentage }}
          </div>
        </div>
        <div
          style="display: grid;
             grid-template-columns: repeat(8,minmax(0,1fr));
             grid-gap: 12px"
        >
          <v-card
            v-for="(it,index) in item.allStore"
            :key="index"
            class="mr-2 pa-2"
            elevation="0"
            outlined
          >
            <v-responsive :aspect-ratio="1">
              <div
                class="d-flex flex-column align-center justify-center"
                style="height: 100%"
              >
                <div>
                  {{ it.name }}
                </div>
                <v-spacer />
                <v-icon
                  v-if="it.reportFinished === 1"
                  color="green"
                >
                  mdi-check-circle-outline
                </v-icon>
              </div>
            </v-responsive>
          </v-card>
        </div>
      </v-card>
    </div>
    <div v-else>
      <div
        style="display: grid;
             grid-template-columns: repeat(4,minmax(0,1fr));
             grid-gap: 12px"
      >
        <v-card
          v-for="item in dayItems"
          :key="item.id"
          class="pa-4 mb-4"
          color="#eee"
          outlined
          width="100%"
        >
          <div class="d-flex align-center justify-center">
            <div>
              <div class="d-flex text-body-1">
                <div>
                  <div>@{{ item.date }}</div>
                </div>
                <v-spacer />
              </div>
              <div>{{ item.name }}</div>
            </div>
            <v-spacer />
            <div>
              <v-icon
                v-if="item.reportFinished === 1"
                color="green"
              >
                mdi-check-circle-outline
              </v-icon>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <v-dialog
      v-model="settingManage"
      max-width="800px"
    >
      <v-card class="pa-4">
        <branding-report-setting />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="newReport"
      max-width="400px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-h4 font-weight-bold">
            {{ reportType }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="newReport = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div v-if="reportType === '日报'">
          <v-dialog
            ref="dialog"
            v-model="dayDialog"
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="selectedDay"
                :rules="rules"
                hide-details
                outlined
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="selectedDay"
              :max="today"
              @input="dayDialog=false"
            />
          </v-dialog>
        </div>
        <div v-else-if="reportType === '月报'">
          <v-dialog
            ref="dialog"
            v-model="monthDialog"
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="selectedMonth"
                :rules="rules"
                hide-details
                outlined
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="selectedMonth"
              :max="thisMonth"
              type="month"
              @input="monthDialog=false"
            />
          </v-dialog>
        </div>
        <v-btn
          class="mt-8 mb-2 amber lighten-4"
          outlined
          width="100%"
          @click="save"
        >
          保存
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import { today } from '@/model/utils/DateRepository'
import dayjs from 'dayjs'
import BrandingReportSetting from '@/views/AadenPages/branding/fragments/BrandingReportSetting.vue'

export default {
  name: 'DataManagement',
  components: { BrandingReportSetting, PageHeader },
  data () {
    return {
      allReportList: ['销售报告', '营业报告', '员工报告', '盈利报告'],
      settingManage: false,
      titleGroup: null,
      titleList: [{ value: 'day', type: '日报' }, { value: 'week', type: '周报' }, { value: 'month', type: '月报' }],
      dayItems: [{ name: '杨国福1111111', reportFinished: 1, date: '2024-02-06' }, { name: '杨国福1112221', reportFinished: 1, date: '2024-02-06' }, { name: '杨国福22223333', reportFinished: 1, date: '2024-02-06' }],
      weekItems: [{ id: 1, allStore: [{ name: '杨国福1111111', reportFinished: 1 }, { name: '杨国福22222', reportFinished: 1 }, { name: '杨国福3', reportFinished: 0 }], date: '第50周', percentage: '66.6%' },
        { id: 2, allStore: [{ name: '杨国福1111111', reportFinished: 1 }, { name: '杨国福22222', reportFinished: 0 }, { name: '杨国福3', reportFinished: 0 }], date: '第51周', percentage: '33.3%' },
        { id: 3, allStore: [{ name: '杨国福1111111', reportFinished: 1 }, { name: '杨国福22222', reportFinished: 1 }, { name: '杨国福3', reportFinished: 1 }], date: '第52周', percentage: '100%' }],
      monthItems: [{ id: 1, allStore: [{ name: '杨国福1111111', reportFinished: 1 }, { name: '杨国福22222', reportFinished: 1 }, { name: '杨国福3', reportFinished: 0 }], date: '2024-02', percentage: '66.6%' },
        { id: 2, allStore: [{ name: '杨国福1111111', reportFinished: 1 }, { name: '杨国福22222', reportFinished: 0 }, { name: '杨国福3', reportFinished: 0 }], date: '2024-01', percentage: '33.3%' },
        { id: 3, allStore: [{ name: '杨国福1111111', reportFinished: 1 }, { name: '杨国福22222', reportFinished: 1 }, { name: '杨国福3', reportFinished: 1 }], date: '2023-12', percentage: '100%' }],
      rules: [
        v => !!v || '日期是必填项'
      ],
      thisMonth: dayjs().format('YYYY-MM'),
      today,
      selectedMonth: null,
      monthDialog: null,
      selectedDay: null,
      dayDialog: null,
      newReport: false,
      currentDate: '',
      reportType: '月报'
    }
  },
  watch: {
    titleGroup (val) {
      this.reportType = this.titleList[val].type
      console.log(this.reportType, 'type')
    }
  },
  methods: {
    createReport () {
      this.newReport = true
    },
    save () {}
  }
}
</script>

<style scoped>

</style>
